module.exports = __webpack_public_path__ + "img/text.4adb03d6.svg";